<template>
    <div class="enter-layout">
        <aside
            class="enter-box"
            v-for="item in enterList"
            :key="item.name"
            @click="handleEnter(item.routerName)"
        >
            <img id="icon" :src="item.icon" />
            <div class="enter-box__text-box">
                <span class="enter-box__text-box__title">{{item.name}}</span>
                <span class="enter-box__text-box__link-text">立即前往 >></span>
            </div>
        </aside>
    </div>
</template>

<script>
export default {
  data() {
    return {
      enterList: [{
        name: '发起融资申请',
        icon: require('@/assets/images/financing-apply-icon.png'),
        routerName: 'financing-apply'
      }, {
        name: '浏览金融产品',
        icon: require('@/assets/images/view-product-icon.png'),
        routerName: 'product'
      }]
    }
  },
  methods: {
    handleEnter(routerName) {
      this.$router.push({
        name: routerName
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.enter-layout {
    @include displayCenter;
    padding-bottom: 45px;
}
.enter-box {
    @include displayCenter;
    cursor: pointer;
    &__text-box{
        @include displayCenter($align-items:flex-start);
        margin-left: 30px;
        flex-direction: column;
        &__title {
            white-space: nowrap;
            @include text-28-bold;
            line-height: 28px;
            color:rgba(41,84,208,1);
            font-size: 20px;
        }
        &__link-text {
            @include text-18-400;
            color:rgba(102,102,102,1);
            padding-top: 7px;
            line-height:20px;
            font-size: 16px;
            &:hover {
                border-bottom: 1px rgba(102,102,102,1) solid;
                margin-bottom: -1px;
            }
        }
    }
}
.enter-box + .enter-box {
    margin-left:330px;
}
#icon {
    height: 55px;
    opacity: 0.8;
}
</style>
